import { Link } from "react-router-dom";
import { contentPrinciples, siteInfo } from "@/mocks/site";

export default function AboutStrip() {
  return (
    <section
      className="w-full bg-secondary-950 text-secondary-100"
      aria-labelledby="home-about-title"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-5">
            <p className="text-xs tracking-[0.3em] text-accent-400 mb-3">ABOUT</p>
            <h2
              id="home-about-title"
              className="font-heading text-2xl md:text-3xl font-bold text-background-50 leading-snug"
            >
              我们把零散片段，整理成能顺着读下去的合集
            </h2>
            <p className="text-sm md:text-base leading-relaxed text-secondary-200/90 mt-5">
              {siteInfo.intro}
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-1.5 mt-6 text-sm font-medium text-accent-400 hover:text-accent-300 transition-colors"
            >
              了解我们的整理原则
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {contentPrinciples.map((item) => (
              <div
                key={item.title}
                className="bg-secondary-900 border border-secondary-800 rounded-lg p-5 md:p-6"
              >
                <span className="w-10 h-10 rounded-md bg-accent-500 text-secondary-950 flex items-center justify-center text-lg">
                  <i className={item.icon} aria-hidden="true" />
                </span>
                <h3 className="font-heading text-base font-bold text-background-50 mt-4">
                  {item.title}
                </h3>
                <p className="text-sm leading-relaxed text-secondary-200/85 mt-2">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}